import OfferUrgencyCountdownLabel from 'components/Common/Labels/OfferUrgencyCountdownLabel'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import LuxPlusLabelWithModal from 'luxPlus/components/LuxPlusLabelWithModal'
import React from 'react'
import { useIntl } from 'react-intl'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'

interface Props {
  offer: App.TourOffer | App.TourOfferSummary | App.CruiseOffer
  label: App.OfferUrgencyLabel
}

function CruiseUrgencyLabel(props: Props) {
  const { offer, label } = props
  const intl = useIntl()

  switch (label.type) {
    case 'agenthub_exclusive':
      return <PromotionLabel variant="default">
        {intl.formatMessage({
          id: 'KFNHASgY3E',
          defaultMessage: 'Agent exclusive',
          description: 'Label for agent-exclusive cruise offers',
        })}
      </PromotionLabel>
    case 'left':
      return <OfferUrgencyCountdownLabel endDate={label.end!} tagPlace="cruise-urgency-label" />
    case 'sale':
      return <PromotionLabel icon={<SolidFireIcon />} variant="premium">{label.message}</PromotionLabel>
    case 'lux_plus_member_price':
      return <LuxPlusLabelWithModal
        type="member-price-offer-tour"
        saveAmount={label.saveAmount}
        offer={offer}
      />
    default:
      return null
  }
}

export default CruiseUrgencyLabel
